module.exports = __webpack_public_path__ + "static/media/cloud4@2x.e71332ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/AttractLoopView/cloud4@2x.png
// module id = 870
// module chunks = 0